import { render, staticRenderFns } from "./AssessmentsSetting.vue?vue&type=template&id=3fd0b2fe&scoped=true"
import script from "./AssessmentsSetting.vue?vue&type=script&lang=ts"
export * from "./AssessmentsSetting.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentsSetting.vue?vue&type=style&index=0&id=3fd0b2fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd0b2fe",
  null
  
)

export default component.exports